import { useSelection } from "@frend-digital/centra/client";

export const useAuth = () => {
  const { data: selection, isLoading } = useSelection();

  return {
    token: selection?.token,
    isLoading,
    isLoggedIn: !!selection?.loggedIn,
    user: selection?.loggedIn,
  };
};
